export const continuePathQueryParam = 'continuePath';
export const tenantSubDomainQueryParam = 'tenantSubDomain';
export const tokenQueryParam = 'token';
export const isSessionExpiredQueryParam = 'isSessionExpired';
